module.exports = __webpack_public_path__ + "img/60.392ad144.jpg";